module.exports = __webpack_public_path__ + "static/media/TMS-home-banner.befec905.png";